import classNames from 'classnames';
import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import React from 'react';
import { FiCheck, FiEdit, FiEye, FiFile } from "react-icons/fi";
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Truncate from 'react-truncate';
import { withStateHandlers } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { dateFormats } from '../../../../../constants';
import { currentUserSelector } from '../../../../../state/modules/user';
import Tooltip from '../../../../components/tooltip';

const QualificationTile = ({ qualification, goTo, onDescriptionTruncate, descriptionTruncated, nextRoute, currentUser }) => {
  const containsAttachments = !fp.flow(
    fp.get('attachments'),
    fp.isEmpty
  )(qualification)

  const allowEdit = currentUser.id === qualification.userId

  const redirect = () => goTo(nextRoute)

  return <div className='qualification-tile'>
    <div id='manager-approval' className={classNames('flexbox center align-center', { invisible: !qualification.approved })}>
      <FiCheck /> Manager Approved
    </div>
    <div id='qualification-name'>
      <Truncate lines={2}>{qualification.name}</Truncate>
    </div>
    <div id='qualification-details'>
      <Tooltip
        disabled={!descriptionTruncated}
        placement='bottom'
        component={<Truncate lines={1} onTruncate={onDescriptionTruncate}>{qualification.description}</Truncate>}
        tip={<p className='padding-thin tip'>{qualification.description}</p>} />
    </div>
    <div id='qualification-upload-date'>
      {dateFnsCompat.format(dateFnsCompat.parse(qualification.metaData.dateCreated), dateFormats.ShortDate)}
    </div>
    <div id='qualification-attachments' className={classNames({ visible: containsAttachments })}>
      <FiFile /> Attachments
    </div>
    <div id='qualification-actions' className='flexbox end'>
      {
        allowEdit ?
          <FiEdit id='edit' onClick={redirect} /> :
          <FiEye id='edit' onClick={redirect} />
      }
    </div>
  </div>
}

const mapStateToProps = (state) => ({
  currentUser: currentUserSelector(state)
})
const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      descriptionTruncated: false
    },
    {
      onDescriptionTruncate: () => (descriptionTruncated) => ({ descriptionTruncated })
    }
  )
)(QualificationTile)


// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/qualifications/qualification-tile.js